<template>
	<div v-if="languageLoaded" class="page">

		<Sidebar />

		<div class="page-main">
			<div class="page-main-logo" />
			<div class="page-main-content">
				<router-view />
			</div>
		</div>

	</div>
</template>

<script>
import '@/style/onboarding.scss'
import loadTranslations from '@/services/mixins/loadTranslations'
import setDefaultLanguage from '@/services/mixins/setDefaultLanguage'

export default {
	name: 'PublicLayout',
	mixins: [
		loadTranslations,
		setDefaultLanguage
	],
	components: {
		Sidebar: () => import( /* webpackPrefetch: true */ '@/views/Public/Components/Sidebar')
	},
	data () {
		return {
			languageLoaded: false
		}
	},
	created () {
		this.loadTranslations(this.setDefaultLanguage())
	}
}
</script>

<style lang="scss" scoped>
.page {

	background-color: #fff;
	@include flex(flex, row, wrap, flex-start, flex-start);

	&-main {

		@include flex(flex, column, wrap, center, center);
		min-height: 100vh;
		padding: 0 30px;
		position: relative;
		width: calc(100% - #{$onboarding-sidebar-width});

		@include breakpoint(md) {
			width: 50%;
		}

		@include breakpoint(sm) {
			padding: 50px 0;
			width: 100%;
		}

		&-logo {
			aspect-ratio: 1;
			@include background-image(logo-vertical, svg, contain, center, no-repeat);
			display: block;
			margin-bottom: 30px;
			width: 120px;
		}

		&-content {

			color: $color-text;
			font-size: $font-size - 1;
			max-width: 100%;
			width: 400px;

			@include breakpoint(xs) {
				margin: 0 10%;
				width: 80%;
			}

		}

	}

}
</style>
